import React from 'react'
import PropTypes from 'prop-types'
import { get, isEmpty } from 'lodash'
import styled from 'styled-components'
import * as Yup from 'yup'
import { Formik, Form } from 'formik'
import { connect } from 'react-redux'
import Container from './Container'
import ContentWrapper from './ContentWrapper'
import ViewSlider from './ViewSlider'
import GenericInputField from './GenericInputField'
import Captcha from './Captcha'
import {
    ContentfulSideBySideInputFieldComponent,
    ContentfulRadioCheckBoxFieldComponent,
    ContentfulRightSideContentViewComponent,
    ContentfulLeftSideContentViewComponent,
    fieldPatterns,
    ContentfulBusinessMarketingPermissionFieldName,
    ContentfulPersonMarketingPermissionFieldName,
    ContentfulBusinessAdditionalInformationFieldName,
    ContentfulPersonTermsOfUseFieldName,
    businessCustomerType,
    personCustomerType,
    businessLanguage,
    personLanguage,
    MAX_CHARACTER_COUNT,
    RESPONSIVE_SCREEN_WIDTH_LARGE,
    BUSINESS_MARKETING_PERMISSION_DEFAULT,
    PERSON_MARKETING_PERMISSION_DEFAULT,
    ContentfulStaticInformationFieldComponent,
    CaptchaValueFieldName,
} from '../constants/GeneralConstants'
import {
    CreateBusinessCustomerUrl,
    CreatePersonCustomerUrl,
} from '../constants/IntegrationConstants'
import FormThankYouPage from './FormThankYouPage'

const Content = styled.div`
    flex: 70%;
    width: 100%;

    @media (max-width: ${props => props.theme.responsive.large}) {
        flex: 100%;
        margin-top: 0;
        padding-left: 1em;
        padding-right: 1em;
    }
`

const InputField = styled.div`
    flex: 100%;
    width: 100%;
`

const FormWrapper = styled(Form)`
    width: 100%;
`

const StyledContainer = styled(Container)`
    display: flex;
    flex-wrap: wrap;
    min-height: 1200px;
    padding: 0;
`

const StyledWrapper = styled(ContentWrapper)`
    padding-top: 26px;
    max-width: 640px;
    display: flex;
    max-width: 80%;
    margin: 0 auto;
    float: none;
`

const ContentViewNextButton = styled.div`
    width: 160px;
    height: 35px;
    background-color: ${props => props.theme.colors.lightGreenText};
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    text-decoration: none;
    font-weight: 100;
    text-transform: uppercase;
    font-size: 13px;
    cursor: pointer;

    @media (max-width: ${props => props.theme.responsive.small}) {
        flex: 100%;
        margin-left: 0;
    }

    &:hover {
        opacity: 0.8;
    }
`
const ContentViewPreviousButton = styled.div`
    width: 160px;
    height: 35px;
    margin-right: 1em;
    background-color: ${props => props.theme.colors.lightGreenText};
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    text-decoration: none;
    font-weight: 100;
    text-transform: uppercase;
    font-size: 13px;
    cursor: pointer;

    @media (max-width: ${props => props.theme.responsive.small}) {
        flex: 100%;
        margin-right: 0;
    }

    &:hover {
        opacity: 0.8;
    }
`

const CancelButton = styled.div`
    width: 150px;
    height: 35px;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${props => props.theme.colors.lightGreenText};
    text-decoration: none;
    font-weight: 100;
    text-transform: uppercase;
    font-size: 13px;
    cursor: pointer;
    margin-left: 1em;
    border: 1px solid ${props => props.theme.colors.lightGreenText};
    float: left;

    @media (max-width: ${props => props.theme.responsive.small}) {
        flex: 100%;
        margin-left: 0em;
        width: 120px;
    }

    &:hover {
        border-width: 2px;
        font-weight: 600;
    }
`

const SubmitButton = styled.button`
    width: 150px;
    height: 35px;
    background-color: ${props => props.theme.colors.blue};
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${props => props.theme.colors.whiteText};
    text-decoration: none;
    font-weight: 100;
    text-transform: uppercase;
    font-size: 1rem;
    cursor: pointer;
    margin-left: 0em;
    border: 1px solid ${props => props.theme.colors.blue};
    float: left;

    @media (max-width: ${props => props.theme.responsive.small}) {
        flex: 100%;
        margin-left: 0em;
        width: 120px;
    }

    &:hover {
        border-width: 2px;
        background: rgb(58, 127, 01) !important;
    }
`

const ButtonWrapper = styled.div`
    flex: 100%;
    display: flex;
    flex-wrap: wrap;
    float: left;
    .disabled {
        pointer-events: none;
    }
`
/*
    @media (max-width: ${props => props.theme.responsive.large}) {
            flex: 100%;
            width: 100%;
        }
*/
const ButtonAndCaptchaWrapper = styled.div``

/*
    @media (max-width: ${props => props.theme.responsive.large}) {
        width: 100%;
    }

*/

const ContentView = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 2em;
    word-break: break-word;
    flex-wrap: wrap;
    position: relative;

    &:invalid {
        ${ContentViewNextButton} {
            pointer-events: none;
            background-color: ${props => props.theme.colors.invalidButtonGrey};
        }
        textarea {
            &:required {
                &.invalid {
                    border: 1px solid red;
                }
            }
        }
    }
`

const MissingFieldsWrapper = styled.div`
    margin-top: 10px;
`

const MissingFieldsTitle = styled.div`
    font-weight: bold;
`

const MissingFieldsList = styled.div`
    margin-left: 20px;
    li {
        list-style-type: circle;
    }
`

class FormContainer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeView: 0,
            isSubmitted: false,
            isLargeView: false,
        }
        this.nextView = this.nextView.bind(this)
        this.lastView = this.lastView.bind(this)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }

    componentDidMount() {
        this.updateWindowDimensions()
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions() {
        this.setState({
            isLargeView: window.innerWidth > RESPONSIVE_SCREEN_WIDTH_LARGE,
        })
    }

    nextView = () => {
        const { activeView } = this.state
        this.setState({
            activeView: activeView + 1,
        })
        window.scrollTo(0, 0)
    }

    lastView = () => {
        const { activeView } = this.state
        this.setState({
            activeView: activeView - 1,
        })
        window.scrollTo(0, 0)
    }

    hasErrorsInCurrentView = (values, errors, touched, isLastPage) => {
        if (isEmpty(values)) {
            return true
        }
        if (!isEmpty(errors)) {
            return true
        }
        if (isEmpty(touched)) {
            return true
        }

        const { activeView } = this.state
        const { data } = this.props
        const { contentViews } = data.contentfulForm
        const contentView = contentViews[activeView]

        let emptyRequiredValuesInCurrentView = false
        contentView.contentInputFields.forEach(item => {
            if (item.inputFields) {
                item.inputFields.forEach(nestedItem => {
                    if (
                        nestedItem.required &&
                        values[nestedItem.integrationObjectName] === ''
                    ) {
                        emptyRequiredValuesInCurrentView = true
                    }
                })
            }
            if (item.required === true) {
                // if field is empty or required checkbox is unchecked
                if (
                    values[item.integrationObjectName] === '' ||
                    values[item.integrationObjectName] === false
                ) {
                    emptyRequiredValuesInCurrentView = true
                }
            }
        })

        if (values[CaptchaValueFieldName] === null && isLastPage) {
            emptyRequiredValuesInCurrentView = true
        }

        return emptyRequiredValuesInCurrentView
    }

    previousView = () => {
        const { activeView } = this.state
        if (activeView > 0) {
            this.setState({
                activeView: activeView - 1,
            })
        } else {
            this.setState({
                activeView: 0,
            })
        }
        window.scrollTo(0, 0)
    }

    setActiveView = index => {
        this.setState({
            activeView: index,
        })
    }

    getIntegrationObjectInitialValues(fieldData) {
        const initialValues = {}
        fieldData.forEach(element => {
            if (element.contentInputFields) {
                element.contentInputFields.forEach(elementField => {
                    if (
                        elementField.__typename ===
                            ContentfulRightSideContentViewComponent ||
                        elementField.__typename ===
                            ContentfulLeftSideContentViewComponent
                    ) {
                        const hasArrayOfFields =
                            elementField.contentFields &&
                            Array.isArray(elementField.contentFields)
                        if (hasArrayOfFields) {
                            elementField.contentFields.forEach(e => {
                                if (e.integrationObjectName) {
                                    initialValues[e.integrationObjectName] = ''
                                }
                            })
                        }
                    }

                    if (
                        elementField.__typename ===
                        ContentfulSideBySideInputFieldComponent
                    ) {
                        elementField.inputFields.forEach(e => {
                            if (e.integrationObjectName) {
                                initialValues[e.integrationObjectName] = ''
                            }
                        })
                    } else if (
                        elementField.integrationObjectName &&
                        elementField.__typename !==
                            ContentfulRadioCheckBoxFieldComponent
                    ) {
                        initialValues[elementField.integrationObjectName] = ''
                    } else if (
                        elementField.__typename ===
                        ContentfulRadioCheckBoxFieldComponent
                    ) {
                        if (elementField.checkboxOrRadiobutton === true) {
                            if (elementField.selections.length > 1) {
                                initialValues[
                                    elementField.integrationObjectName
                                ] = []
                            } else if (
                                elementField.integrationObjectName ===
                                CaptchaValueFieldName
                            ) {
                                initialValues[
                                    elementField.integrationObjectName
                                ] = null
                            } else {
                                initialValues[
                                    elementField.integrationObjectName
                                ] = false
                            }
                        } else {
                            initialValues[elementField.integrationObjectName] =
                                ''
                        }
                    }
                })
            }
        })

        // set default values
        const customerType = get(this.props, 'data.contentfulForm.customerType')
        const customerLocale = get(
            this.props,
            'data.contentfulForm.node_locale',
        )
        if (customerType === businessCustomerType) {
            initialValues[
                ContentfulBusinessMarketingPermissionFieldName
            ] = BUSINESS_MARKETING_PERMISSION_DEFAULT
            initialValues[businessLanguage] = this.getLocaleLanguage(
                customerLocale,
            )
        }
        if (customerType === personCustomerType) {
            initialValues[
                ContentfulPersonMarketingPermissionFieldName
            ] = PERSON_MARKETING_PERMISSION_DEFAULT
            initialValues[personLanguage] = this.getLocaleLanguage(
                customerLocale,
            )
        }
        return initialValues
    }

    getInputFieldNames(contentfulForm) {
        const { contentViews } = contentfulForm
        const fieldNames = {}
        contentViews.forEach(element => {
            if (element.contentInputFields) {
                element.contentInputFields.forEach(elementField => {
                    if (
                        elementField.__typename ===
                            ContentfulRightSideContentViewComponent ||
                        elementField.__typename ===
                            ContentfulLeftSideContentViewComponent
                    ) {
                        const hasArrayOfFields =
                            elementField.contentFields &&
                            Array.isArray(elementField.contentFields)
                        if (hasArrayOfFields) {
                            elementField.contentFields.forEach(e => {
                                if (e.integrationObjectName) {
                                    fieldNames[e.integrationObjectName] =
                                        e.header
                                }
                            })
                        }
                    }

                    if (
                        elementField.__typename ===
                        ContentfulSideBySideInputFieldComponent
                    ) {
                        elementField.inputFields.forEach(e => {
                            if (e.integrationObjectName) {
                                fieldNames[e.integrationObjectName] = e.header
                            }
                        })
                    } else if (
                        elementField.integrationObjectName &&
                        elementField.__typename !==
                            ContentfulRadioCheckBoxFieldComponent
                    ) {
                        fieldNames[elementField.integrationObjectName] =
                            elementField.header
                    } else if (
                        elementField.__typename ===
                        ContentfulRadioCheckBoxFieldComponent
                    ) {
                        if (elementField.checkboxOrRadiobutton === true) {
                            if (elementField.selections.length > 1) {
                                fieldNames[elementField.integrationObjectName] =
                                    elementField.header
                            } else {
                                fieldNames[elementField.integrationObjectName] =
                                    elementField.header
                            }
                        } else {
                            fieldNames[elementField.integrationObjectName] =
                                elementField.header
                        }
                    }
                })
            }
        })
        return fieldNames
    }

    // assume that locale is given in iso-639 format
    getLocaleLanguage(localeString) {
        return localeString.split('-')[0]
    }

    submit(values) {
        const { data } = this.props

        const siteMetadata = get(data, 'site.siteMetadata')
        const customerType = get(data, 'contentfulForm.customerType')
        let targetUrl, formName

        if (customerType === businessCustomerType) {
            targetUrl = `${siteMetadata.frendsApiBaseurl}${CreateBusinessCustomerUrl}`
            formName = 'new-business-customer'
        }
        if (customerType === personCustomerType) {
            targetUrl = `${siteMetadata.frendsApiBaseurl}${CreatePersonCustomerUrl}`
            formName = 'new-person-customer'
        }

        fetch(targetUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-ApiKey': siteMetadata.frendsApiKeyHeader,
            },
            body: JSON.stringify({ 'form-name': formName, ...values }),
        })
            .then(this.handleSuccess)
            .catch(error => alert(error))
    }

    handleSuccess() {
        console.log('Form successfully sent')
    }

    setSubmitted() {
        this.setState({
            isSubmitted: true,
        })
        window.scrollTo(0, 0)
    }

    formSchema(contentViews) {
        const yupShapeViews = []
        contentViews.forEach(contentView => {
            const yupShape = {}
            contentView.contentInputFields.forEach(field => {
                if (
                    field.__typename ===
                        ContentfulRightSideContentViewComponent ||
                    field.__typename === ContentfulLeftSideContentViewComponent
                ) {
                    const hasArrayOfFields =
                        field.contentFields &&
                        Array.isArray(field.contentFields)
                    if (hasArrayOfFields) {
                        field.contentFields.forEach(contentField => {
                            if (
                                contentField.__typename ===
                                ContentfulRadioCheckBoxFieldComponent
                            ) {
                                if (
                                    contentField.checkboxOrRadiobutton === true
                                ) {
                                    if (contentField.selections.length > 1) {
                                        yupShape[
                                            contentField.integrationObjectName
                                        ] = Yup.array()
                                            .required(
                                                contentField.validationErrorMessage,
                                            )
                                            .strict()
                                    } else if (
                                        contentField.selections.length === 1 &&
                                        contentField.required === true
                                    ) {
                                        if (
                                            contentField.integrationObjectName ===
                                            CaptchaValueFieldName
                                        ) {
                                            yupShape[
                                                contentField.integrationObjectName
                                            ] = Yup.string()
                                                .required(
                                                    contentField.validationErrorMessage,
                                                )
                                                .strict()
                                                .matches(
                                                    fieldPatterns[
                                                        contentField
                                                            .integrationObjectName
                                                    ],
                                                    contentField.validationErrorMessage,
                                                )
                                        } else {
                                            yupShape[
                                                contentField.integrationObjectName
                                            ] = Yup.boolean()
                                                .oneOf(
                                                    [true],
                                                    contentField.validationErrorMessage,
                                                )
                                                .required(
                                                    contentField.validationErrorMessage,
                                                )
                                                .strict()
                                        }
                                    } else {
                                        yupShape[
                                            contentField.integrationObjectName
                                        ] = Yup.boolean()
                                            .required(
                                                contentField.validationErrorMessage,
                                            )
                                            .strict()
                                    }
                                }
                            } else if (
                                contentField.internal &&
                                contentField.internal.type !==
                                    ContentfulStaticInformationFieldComponent
                            ) {
                                yupShape[
                                    contentField.integrationObjectName
                                ] = Yup.string()
                                    .required(
                                        contentField.validationErrorMessage,
                                    )
                                    .strict()
                                    .matches(
                                        fieldPatterns[
                                            contentField.integrationObjectName
                                        ],
                                        contentField.validationErrorMessage,
                                    )
                            }
                        })
                    }
                }

                if (
                    field.__typename === ContentfulSideBySideInputFieldComponent
                ) {
                    field.inputFields.forEach(inputField => {
                        yupShape[
                            inputField.integrationObjectName
                        ] = Yup.string()
                            .required(inputField.validationErrorMessage)
                            .strict()
                            .matches(
                                fieldPatterns[inputField.integrationObjectName],
                                inputField.validationErrorMessage,
                            )
                    })
                } else if (
                    field.__typename === ContentfulRadioCheckBoxFieldComponent
                ) {
                    if (field.checkboxOrRadiobutton === true) {
                        if (field.selections.length > 1) {
                            yupShape[field.integrationObjectName] = Yup.array()
                                .required(field.validationErrorMessage)
                                .strict()
                        } else if (
                            field.selections.length === 1 &&
                            field.required === true
                        ) {
                            if (
                                field.integrationObjectName ===
                                CaptchaValueFieldName
                            ) {
                                yupShape[
                                    field.integrationObjectName
                                ] = Yup.string()
                                    .required(field.validationErrorMessage)
                                    .strict()
                                    .matches(
                                        fieldPatterns[
                                            field.integrationObjectName
                                        ],
                                        field.validationErrorMessage,
                                    )
                            } else {
                                yupShape[
                                    field.integrationObjectName
                                ] = Yup.boolean()
                                    .oneOf([true], field.validationErrorMessage)
                                    .required(field.validationErrorMessage)
                                    .strict()
                            }
                        } else {
                            yupShape[
                                field.integrationObjectName
                            ] = Yup.boolean()
                                .required(field.validationErrorMessage)
                                .strict()
                        }
                    } else {
                        yupShape[field.integrationObjectName] = Yup.string()
                            .required(field.validationErrorMessage)
                            .strict()
                            .matches(
                                fieldPatterns[field.integrationObjectName],
                                field.validationErrorMessage,
                            )
                    }
                } else if (
                    field.integrationObjectName ===
                    ContentfulBusinessAdditionalInformationFieldName
                ) {
                    yupShape[field.integrationObjectName] = Yup.string().test(
                        'len',
                        field.validationErrorMessage,
                        val =>
                            val == null ||
                            val.toString().length <= MAX_CHARACTER_COUNT,
                    )
                } else if (
                    field.__typename !==
                        ContentfulStaticInformationFieldComponent &&
                    field.__typename !==
                        ContentfulRightSideContentViewComponent &&
                    field.__typename !== ContentfulLeftSideContentViewComponent
                ) {
                    yupShape[field.integrationObjectName] = Yup.string()
                        .required(field.validationErrorMessage)
                        .matches(
                            fieldPatterns[field.integrationObjectName],
                            field.validationErrorMessage,
                        )
                }
            })
            yupShapeViews.push(Yup.object().shape(yupShape))
        })
        return yupShapeViews
    }

    FormPage = (
        contentView,
        values,
        setFieldValue,
        touched,
        errors,
        errorMessages,
        setFieldTouched,
        siteMetadata,
        setErrors,
    ) => {
        const {
            theme,
            data: {
                contentfulForm: { customerType },
            },
        } = this.props

        return (
            <div>
                {contentView.contentInputFields &&
                    contentView.contentInputFields.map((field, index) => {
                        return (
                            <InputField key={index}>
                                <GenericInputField
                                    {...this.props}
                                    customerType={customerType}
                                    data={field}
                                    typename={field.__typename}
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    touched={touched}
                                    errors={errors}
                                    errorMessages={errorMessages}
                                    setErrors={setErrors}
                                    theme={theme}
                                    activeView={this.state.activeView}
                                    setFieldTouched={setFieldTouched}
                                    siteMetadata={siteMetadata}
                                />
                            </InputField>
                        )
                    })}
            </div>
        )
    }

    NavigationButtons = (values, errors, touched, handleReset) => {
        const hasErrors = this.hasErrorsInCurrentView(values, errors, touched)

        const {
            data,
            isAcceptedPostalCode,
            data: {
                contentfulForm: { customerType },
            },
        } = this.props
        const { isSubmitted } = this.state

        const nextButtonText = get(data, 'contentfulForm.nextButtonText', '')
        const previousButtonText = get(
            data,
            'contentfulForm.previousButtonText',
            '',
        )
        const cancelButtonText = get(
            data,
            'contentfulForm.cancelButtonText',
            '',
        )
        const submitButtonText = get(
            data,
            'contentfulForm.submitButtonText',
            '',
        )
        const contentViews = get(data, 'contentfulForm.contentViews')

        const isActiveSubmitButton = !hasErrors && isAcceptedPostalCode

        if (contentViews) {
            const isLastPage = this.state.activeView === contentViews.length - 1
            const isFirstPage =
                this.state.activeView === contentViews.length - 3

            return (
                <ButtonWrapper
                    className={
                        customerType === personCustomerType
                            ? this.state.isLargeView
                                ? 'personButtonWrapperLargeView'
                                : 'personButtonWrapperMobileView'
                            : ''
                    }
                >
                    {!isFirstPage && (
                        <ContentViewPreviousButton
                            type="button"
                            onClick={this.lastView}
                        >
                            {previousButtonText}
                        </ContentViewPreviousButton>
                    )}

                    {!isLastPage && (
                        <ContentViewNextButton
                            type="button"
                            onClick={this.nextView}
                            disabled={!hasErrors}
                            className={hasErrors ? 'disabled' : 'active'}
                        >
                            {nextButtonText}
                        </ContentViewNextButton>
                    )}

                    {isLastPage && (
                        <SubmitButton
                            className={
                                isActiveSubmitButton ? 'active' : 'disabled'
                            }
                            type="submit"
                            disabled={!isActiveSubmitButton}
                        >
                            {submitButtonText}
                        </SubmitButton>
                    )}

                    {!isSubmitted && (
                        <CancelButton
                            onClick={() => {
                                handleReset()
                                this.setActiveView(0)
                            }}
                            type="button"
                        >
                            {cancelButtonText}
                        </CancelButton>
                    )}
                </ButtonWrapper>
            )
        }
    }

    MissingFields = (values, errors) => {
        const {
            data: { contentfulForm },
        } = this.props
        const { missingFieldsNotificationText } = contentfulForm

        const errorFieldKeys = Object.keys(errors)
        const fieldNames = this.getInputFieldNames(contentfulForm)
        const errorFields = errorFieldKeys
            .map(errorFieldKey => {
                if (errorFieldKey === CaptchaValueFieldName) {
                    return null
                }
                return fieldNames[errorFieldKey]
            })
            .filter(value => {
                return value
            })

        return (
            !isEmpty(errorFields) &&
            values[ContentfulPersonTermsOfUseFieldName] === true && (
                <MissingFieldsWrapper>
                    <MissingFieldsTitle>
                        {missingFieldsNotificationText}
                    </MissingFieldsTitle>
                    <MissingFieldsList>
                        <ul>
                            {errorFields.map((errorField, index) => {
                                return <li key={index}>{errorField}</li>
                            })}
                        </ul>
                    </MissingFieldsList>
                </MissingFieldsWrapper>
            )
        )
    }

    render() {
        const { theme, data, customerType } = this.props

        const {
            contentViews,
            thankYouPageHeader,
            thankYouPageTitle,
            thankYouPageBody,
        } = data.contentfulForm

        const { siteMetadata } = data.site

        const { activeView, isSubmitted } = this.state

        const initialValues = this.getIntegrationObjectInitialValues(
            contentViews,
        )
        const isLastPage = activeView === contentViews.length - 1
        const formSchemas = this.formSchema(contentViews)
        const formSchema = formSchemas[activeView]
        const contentView = contentViews[activeView]

        const isPerson = customerType === personCustomerType

        return (
            <>
                {contentView && (
                    <StyledContainer>
                        <Content>
                            <StyledWrapper>
                                <Formik
                                    initialValues={initialValues}
                                    enableReinitialize={true}
                                    onSubmit={values => {
                                        this.submit(values)
                                        this.setSubmitted()
                                    }}
                                    validationSchema={formSchema}
                                    initialTouched={{
                                        ContentfulMarketingPermissionFieldName: true,
                                    }}
                                >
                                    {({
                                        values,
                                        setFieldValue,
                                        touched,
                                        errors,
                                        errorMessages,
                                        handleReset,
                                        setFieldTouched,
                                        setErrors,
                                    }) => (
                                        <>
                                            {!isSubmitted && (
                                                <ViewSlider
                                                    contentViews={contentViews}
                                                    setActiveView={
                                                        this.setActiveView
                                                    }
                                                    activeView={
                                                        this.state.activeView
                                                    }
                                                    nextView={this.nextView}
                                                    previousView={
                                                        this.previousView
                                                    }
                                                    addToIndex={0}
                                                    id={'navigation'}
                                                    theme={theme}
                                                    hasErrorsInCurrentView={this.hasErrorsInCurrentView(
                                                        values,
                                                        errors,
                                                        touched,
                                                        isLastPage,
                                                    )}
                                                    isPerson={isPerson}
                                                />
                                            )}
                                            <ContentView>
                                                {!isSubmitted && (
                                                    <FormWrapper>
                                                        {this.FormPage(
                                                            contentViews[
                                                                activeView
                                                            ],
                                                            values,
                                                            setFieldValue,
                                                            touched,
                                                            errors,
                                                            errorMessages,
                                                            setFieldTouched,
                                                            siteMetadata,
                                                            setErrors,
                                                        )}

                                                        <ButtonAndCaptchaWrapper
                                                            className={
                                                                customerType ===
                                                                personCustomerType
                                                                    ? this.state
                                                                          .isLargeView
                                                                        ? 'personButtonAndCaptchaWrapperLargeView'
                                                                        : 'personButtonAndCaptchaWrapperMobileView'
                                                                    : ''
                                                            }
                                                        >
                                                            {isLastPage && (
                                                                <Captcha
                                                                    setFieldValue={
                                                                        setFieldValue
                                                                    }
                                                                    theme={
                                                                        theme
                                                                    }
                                                                    values={
                                                                        values
                                                                    }
                                                                />
                                                            )}
                                                            {this.NavigationButtons(
                                                                values,
                                                                errors,
                                                                touched,
                                                                handleReset,
                                                            )}
                                                        </ButtonAndCaptchaWrapper>
                                                    </FormWrapper>
                                                )}

                                                {isSubmitted && (
                                                    <FormThankYouPage
                                                        theme={theme}
                                                        title={
                                                            thankYouPageTitle
                                                        }
                                                        header={
                                                            thankYouPageHeader
                                                        }
                                                        body={thankYouPageBody}
                                                    />
                                                )}
                                            </ContentView>
                                        </>
                                    )}
                                </Formik>
                            </StyledWrapper>
                        </Content>
                    </StyledContainer>
                )}
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        isAcceptedPostalCode: state.areaCodeReducer.isAcceptedPostalCode,
        customerType: state.customerTypeReducer.customerType,
    }
}

FormContainer.propTypes = {
    nextButtonText: PropTypes.string,
    previousButtonText: PropTypes.string,
    cancelButtonText: PropTypes.string,
    theme: PropTypes.object,
    data: PropTypes.object,
    isAcceptedPostalCode: PropTypes.bool,
    customerType: PropTypes.string,
}

export default connect(mapStateToProps)(FormContainer)
